import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * <SEO> — per-page metadata.
 *
 * Sets <title>, <meta name="description">, OG tags, Twitter tags and a
 * canonical <link>. Each route that needs unique SEO should drop one
 * of these in.
 *
 * The defaults fall back to clarias.in's homepage values from
 * /app/frontend/public/index.html so anything not passed in is still
 * sensible.
 */
const DEFAULT_OG_IMAGE = "https://clarias.in/og-image.png";
const SITE_URL = "https://clarias.in";

const SEO = ({
  title,
  description,
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  noindex = false,
}) => {
  const fullCanonical = canonical
    ? canonical.startsWith("http")
      ? canonical
      : `${SITE_URL}${canonical}`
    : null;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {fullCanonical && <link rel="canonical" href={fullCanonical} />}

      {/* Open Graph */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {fullCanonical && <meta property="og:url" content={fullCanonical} />}
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Crawl directives */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default SEO;
